<template>
    <div v-if="request">
        <div class="camps-request" v-if="request.status === 'pending'">
            <div data-name="camps-request-header">
                <p>CrossProm Request</p>
                <router-link :to="requestUrl" class="ml-4" id="chatroom-view-more">
                    View more >
                </router-link>
            </div>
            <div data-name="camps-request-body">
                <Actions 
                    :request-id = "request.id" 
                    @setRequestData = "setRequestData" />
            </div>
        </div>
        <div v-else data-name="after-action">
            <div :data-name="requestStatus">
                <div class="status">
                    <p>
                        {{requestStatus && requestStatus.toUpperCase()}}
                    </p>
                </div>
            </div>
            <div data-name="to-dashboard">
                <router-link :to="requestUrl">
                    <p>
                        Go to Dashboard >
                    </p>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/Theme/Button'
import {useRoomRequests, useRouter} from '../../../core/hooks'
import Actions from '../../Dashboard/components/Card/TableComponents/Actions'
import {computed} from '@vue/composition-api'

export default {
    name: 'Request',
    components: {
        Button,
        Actions
    },
    props: {
        requests: Array
    },
    setup(props){
        
        const {request} = useRoomRequests(props.requests)
        const {route, router} = useRouter()
        
        const requestStatus = computed(() => request.value && request.value.status === 'accepted' ? 'confirmed' : request.value.status)

        const setRequestData = (id, status) => {
            request.value.status = status.value
        }

        const requestUrl = computed(() => `/dashboard/requests?type=${request.value.side ==='sender' ? 'sent' : 'received'}&id=${request.value.id}`)

        return {
            request,
            setRequestData,
            requestStatus,
            requestUrl
        }
    }
}
</script>

<style lang="scss" scoped>
div.camps-request {
    min-width: 232px;
    border: 1px solid #D6DDE3;
    border-radius: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 12px;
    padding-right: 12px;
    div[data-name="camps-request-header"] {
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            margin: 0;
            color: #333333;
            font-size: 12px;
            font-weight: bold;
        }
        a {
            color: #333333;
            font-size: 11px;
            font-weight: bold;
        }
    }
    div[data-name="camps-request-body"] {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
    }
}
div[data-name="after-action"] {
    display: flex;
    align-items: center;

    p {
        margin-bottom: 0 !important;
    }
    div[data-name="confirmed"] .status, 
    div[data-name="declined"] .status, 
    div[data-name="cancelled"] .status,
    div[data-name="expired"] .status {
        width: 84px;
        height: 20px;
        border-radius: 4px;
        p {
            font-size: 10px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 0;
        }
    }
    div[data-name="confirmed"] .status {
        background: #DCF5E3;
        p {
            color: #2FA84F;
        }
    }
    div[data-name="declined"] .status {
        background: #FEE7EB;
        p {
            color: #FA5C7C;
        }
    }
    div[data-name="cancelled"] .status,
    div[data-name="expired"] .status {
        background: #8d9fa852;
        p {
            color: #8D9FA8;
        }
    }
    div[data-name="to-dashboard"] {
        display: flex;
        align-items: center;
        margin-right: 24px;
        &::before {
            content: '|';
            color: #D6DDE3;
            font-size: 20px;
            margin-left: 12px;
            margin-right: 12px;
        }
        p {
            font-size: 11px;
            font-weight: bold;
            color: #333333;
            margin-bottom: 0;
        }
    }
}
</style>